import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loading: false,
  loadingUpdate: false,
  data: [],
  pagination: {
    page: 1,
    limit: 10,
    total: -1,
  },
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    SET_LOADING: (s, data) => (s.loading = data),
    SET_LOADING_UPDATE: (s, data) => (s.loadingUpdate = data),
    SET_WITHDRAWAL: (s, data) => {
      s.data = data.data;
      s.pagination = data.pagination;
    },
    UPDATE_WITHDRAW_ITEM(state, { id, status, notes }) {
      const idx = state.data.findIndex((i) => i.withdrawalRequestId === id);
      if (idx === -1) return;
      const current = state.data[idx];
      const patch = { status };
      if (status === "wdl_pending" && notes !== undefined) {
        patch.reviewComment = notes;
      } else if (status === "wdl_canceled" && notes !== undefined) {
        patch.notes = notes;
      }
      state.data.splice(idx, 1, { ...current, ...patch });
    },
    RESET: (s) => Object.assign(s, initState()),
  },

  actions: {
    async getWithdrawal({ commit }, params) {
      commit("SET_LOADING", true);
      try {
        const res = await this.$api.get("/v1/portal/withdrawal-requests", {
          params,
        });
        const { data, pagination } = res.data;
        commit("SET_WITHDRAWAL", { data, pagination });
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async updateWithdrawal({ commit }, { id, status, notes }) {
      commit("SET_LOADING_UPDATE", true);
      try {
        const payload = { status };
        if (notes !== undefined && notes !== null && notes !== "") {
          payload.notes = notes;
        }
        const { data: res } = await this.$api.put(
          `/v1/portal/withdrawal-requests/${id}`,
          payload,
        );
        if (res.data) {
          commit("UPDATE_WITHDRAW_ITEM", { id, status, notes });
        }
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("SET_LOADING_UPDATE", false);
      }
    },
  },
};
